import Styles from 'src/components/Styles';

export function getStyleWithColorOnly(): {[index: string]: string} {
  return {
    backgroundColor: '#006DFF26',
    color: Styles.tabBarTextColor,
    allReadTextUnderLine: Styles.Colors.Aramark.primary,
  };
}

export function snackBarColorDescriptor(): string {
  return Styles.Colors.Aramark.primary;
}

export function getToastTextStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    allReadText: {
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m1,
      color: Styles.Colors.Aramark.primary,
      fontFamily: Styles.FontFamily.gothamRegular,
      fontWeight: '700',
    },
  };
}

export function getRightReadMarkIconColor(): string {
  return Styles.Colors.Refive.activeFooterBlue;
}

export function snackBarFontFamily(): string {
  return Styles.FontFamily.gothamRegular;
}

export function cartToastViewStyle() {
  return {
    backgroundColor: Styles.Colors.Aramark.toastBg,
    borderColor: Styles.Colors.Aramark.sky,
  };
}

export function cartToastTextStyle() {
  return {
    color: Styles.tabBarTextColor,
  };
}

export default {
  getStyleWithColorOnly,
  snackBarColorDescriptor,
  getToastTextStyleDescriptor,
  snackBarFontFamily,
  cartToastViewStyle,
  cartToastTextStyle,
};
